var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubblesPublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 440,
    viewBox: "0 0 585 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4777_9037",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 585,
    height: 440
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 585,
    height: 440,
    fill: "url(#paint0_radial_4777_9037)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4777_9037)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 485.75,
    cy: 92.4688,
    r: 90.4688,
    transform: "rotate(90 485.75 92.4688)",
    fill: "url(#paint1_radial_4777_9037)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.036,
    cy: 397.249,
    r: 31.6202,
    transform: "rotate(90 397.036 397.249)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 291.636,
    cy: 207.532,
    r: 57.3293,
    transform: "rotate(90 291.636 207.532)",
    stroke: "#FFFBFB",
    strokeWidth: 15.3355
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.417,
    cy: 21.3247,
    r: 5.27003,
    transform: "rotate(90 365.417 21.3247)",
    fill: "#2AF4D5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.248,
    cy: 276.916,
    r: 2.63501,
    transform: "rotate(90 157.248 276.916)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.861,
    cy: 345.428,
    r: 2.63501,
    transform: "rotate(90 383.861 345.428)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.611,
    cy: 362.115,
    r: 8.78338,
    transform: "rotate(90 219.611 362.115)",
    fill: "#56CCF2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.338,
    cy: 449.076,
    r: 9.66172,
    transform: "rotate(90 575.338 449.076)",
    fill: "#2AF4D5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.848,
    cy: 89.8313,
    r: 19.3234,
    transform: "rotate(90 282.848 89.8313)",
    fill: "#56CCF2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.935,
    cy: 262.862,
    r: 30.1008,
    transform: "rotate(90 469.935 262.862)",
    stroke: "#56CCF2",
    strokeWidth: 15.3355
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.977,
    cy: 412.183,
    r: 223.976,
    transform: "rotate(90 216.977 412.183)",
    fill: "url(#paint2_radial_4777_9037)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 119.483,
    cy: 416.572,
    r: 57.9703,
    transform: "rotate(90 119.483 416.572)",
    fill: "#2AF4D5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.616,
    cy: 124.966,
    r: 20.5365,
    transform: "rotate(90 154.616 124.966)",
    stroke: "#2AF4D5",
    strokeWidth: 4.60064
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.753,
    cy: 155.707,
    r: 10.6516,
    transform: "rotate(90 420.753 155.707)",
    stroke: "#2AF4D5",
    strokeWidth: 1.53355
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.945,
    cy: 436.778,
    r: 10.6516,
    transform: "rotate(90 274.945 436.778)",
    stroke: "#2AF4D5",
    strokeWidth: 1.53355
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4777_9037)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512.975,
    cy: 374.412,
    r: 15.0433,
    transform: "rotate(90 512.975 374.412)",
    stroke: "#2AF4D5",
    strokeWidth: 1.53355
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4777_9037",
    x: 491.03,
    y: 352.467,
    width: 43.8895,
    height: 43.8895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.06709,
    result: "effect1_foregroundBlur_4777_9037"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4777_9037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.578 206.594) scale(435.825 257.891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0059378,
    stopColor: "#266BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183F7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4777_9037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(485.75 92.4688) rotate(90) scale(90.4688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694738,
    stopColor: "#00D1FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AE1FF",
    stopOpacity: 0.11
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4777_9037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.977 412.183) rotate(90) scale(223.976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.826779,
    stopColor: "#00D1FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AE1FF",
    stopOpacity: 0.18
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesPublic);
export default __webpack_public_path__ + "static/media/bubbles-public.85c89a4eb59bf3cbc46e030264ab8523.svg";
export { ForwardRef as ReactComponent };